import { render, staticRenderFns } from "./courseLessons.vue?vue&type=template&id=4c4b9638&scoped=true&"
import script from "./courseLessons.vue?vue&type=script&lang=ts&"
export * from "./courseLessons.vue?vue&type=script&lang=ts&"
import style0 from "./courseLessons.vue?vue&type=style&index=0&id=4c4b9638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b9638",
  null
  
)

export default component.exports